define('app/sds/attribute/sds-attribute',["filter!date", "service!selcomm", "$q", "$timeout", "$parse"], function (dateFilter, SelcommWS, $q, $timeout, $parse) {
	"use strict";
	return {
		//transclude: true,
		controller: {
			bind: {
				"attribute": "=",

				"_add": "&add",
				"_update": "&update",
				"_delete": "&delete",

				"_canAdd": "&canAdd",
				"_canUpdate": "&canUpdate",
				"_canDelete": "&canDelete",

				"displayTextExpr": "@?",
				"selectValuesExpr": "@?",
				"stringTypeExpr": "@?",
				"valueExpr": "@?"
			},
			prototype: {
				format: "shortDate",
				normalizeType: function (type) {
					type = type || "";
					switch (type.toLowerCase()) {
						case "bool":
						case "boolean":
							return "bool";
						case "list":
						case "stringlist":
						case "select":
							return "select";
						case "int":
						case "integer":
							return "int";
						case "string":
						case "text":
							return "text";
						default:
							return type;
					}
				}
			},
			properties: {
				normalizedAttributeType: function () {
					return this.normalizeType((this.attribute || angular.empty).type);
				},
				boundAttributeValue: {
					get: function () {
						if (this._fixValue) {
							return undefined;
						}
						if ("_boundAttributeValue" in this) {
							return this._boundAttributeValue;
						}
						else {
							if (this.attribute) {
								return this._attrValue;
							}
						}
					},
					set: function (newValue) {
						if (this._attrValue === newValue) {
							delete this._boundAttributeValue;
						}
						else {
							this._boundAttributeValue = newValue;
						}
					}
				},
				dropdownBoundAttributeValue: {
					get: function () {
						return this._attrValue;
					},
					set: function (newValue) {
						if (typeof value === "string") {
							var asNumber = Number(newValue);
							if (!isNaN(asNumber)) {
								newValue = asNumber;
							}
						}

						this.boundAttributeValue = newValue;
					}
				},
				dateTimeBoundAttributeValue: {
					get: function () {
						return dateFilter(this.boundAttributeValue, this.format);
					},
					set: function (newValue) {
						return this.boundAttributeValue = newValue;
					}
				},
				state: {
					get: function () {
						if (this._deleting) {
							return "delete";
						}
						else if ("_boundAttributeValue" in this) {
							return "update";
						}
					},
					set: function (newState) {
						switch (newState) {
							case "delete":
								this._deleting = true;
								break;
							case "update":
								this._deleting = false;
								this._boundAttributeValue = this._attrValue;
								break;
							default:
								this._deleting = false;
								delete this._boundAttributeValue;
								break;
						}
					}
				}

			},
			constructor: ["$attrs", "$transclude", "$self", "$watch", "$scope", function ($attrs, $transclude, vm, $watch, $scope) {
				var parsedDisplayTextExpr = $parse(vm.displayTextExpr),
					parsedSelectValuesExpr = $parse(vm.selectValuesExpr),
					parsedStringTypeExpr = $parse(vm.stringTypeExpr),
					parsedValueExpr = $parse(vm.valueExpr);
				!$attrs.canAdd && (vm._canAdd = function () { return true; });
				!$attrs.canUpdate && (vm._canUpdate = function () { return true; });
				!$attrs.canDelete && (vm._canDelete = function () { return true; });

				var isDefined = {
					add: "add" in $attrs,
					update: "update" in $attrs,
					delete: "delete" in $attrs
				};

				function addAttr() {
					var adding = angular.copy(vm.attribute);
					parsedValueExpr.assign({
						$attribute: adding
					}, vm.boundAttributeValue);
					return vm.processing = $q.when(vm._add({
						$adding: adding
					})).then(function () {
						parsedValueExpr.assign({
							$attribute: vm.attribute
						}, vm.boundAttributeValue);
					});
				}
				function updateAttr() {
					var updating = angular.copy(vm.attribute);
					parsedValueExpr.assign({
						$attribute: updating
					}, vm.boundAttributeValue);
					return vm.processing = $q.when(vm._update({
						$updating: updating
					})).then(function() {
						parsedValueExpr.assign({
							$attribute: vm.attribute
						}, vm.boundAttributeValue);
					});
				}
				function deleteAttr() {
					return vm.processing = $q.when(vm._delete({
						$deleting: vm.attribute
					}));
				}

				Object.defineProperties(vm, {
					displayText: { get: function () { return parsedDisplayTextExpr($scope.$parent, { $attribute: vm.attribute }); } },
					possibleValues: { get: function () { return parsedSelectValuesExpr($scope.$parent, { $attribute: vm.attribute }); } },
					stringType: { get: function () { return parsedStringTypeExpr($scope.$parent, { $attribute: vm.attribute }); } },
					add: { get: function () { return isDefined.add ? addAttr : null; } },
					update: { get: function () { return isDefined.update ? updateAttr : null; } },
					delete: { get: function () { return isDefined.delete ? deleteAttr : null; } },
					canAdd: { get: function ($adding) { return this.add && this._canAdd.call(vm, { $adding: $adding }); } },
					canUpdate: { get: function ($updating) { return this.update && this._canUpdate.call(vm, { $updating: $updating }); } },
					canDelete: { get: function ($deleting) { return this.delete && this._canDelete.call(vm, { $deleting: $deleting }); } },
					_attrValue: {
						get: function _attrValue_get() { return parsedValueExpr($scope.$parent, { $attribute: vm.attribute }) },
						set: function _attrValue_set(value) { return parsedValueExpr.assign({ $attribute: vm.attribute }, value); }
					}
				});
			}]
		}
	};
});
